import React from "react";
import { ArmchairIcon, HomeIcon, TreesIcon, UtensilsIcon, WrenchIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { galleryImages, transformableBuilds } from "../data/content";
const icons: Record<string, typeof HomeIcon> = {
  outdoor: TreesIcon,
  home: HomeIcon,
  workshop: WrenchIcon,
  chair: ArmchairIcon,
  table: UtensilsIcon
};
export function TransformableBuilds() {
  const loop = [...galleryImages, ...galleryImages];
  return <section className="bg-white py-16" aria-labelledby="transformable-title" data-id="element-266" data-mp="imiljs2we05w">
      <div className="mx-auto max-w-6xl px-4" data-id="element-267" data-mp="ikflsgby0snz">
        <SectionHeading id="transformable-title" title="Discover the transformable builds" accent="25 smart 2-in-1 & space-saving projects" intro="Not just classic woodworking. Build designs that adapt to the way you live and work." data-id="element-268" data-mp="nktve2t70ao4" />
        <ul className="mt-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-5" data-id="element-269" data-mp="3w153h0z8rc6r">
          {transformableBuilds.map(b => {
          const Icon = icons[b.icon];
          return <li key={b.title} data-id="element-270" data-mp="353xz0fzbprzh">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-peach" data-id="element-271" data-mp="354z8wh4ls8fm">
                  <Icon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-272" data-mp="30c64xvgyl44l" />
                </span>
                <h3 className="mt-3 font-heading text-sm font-bold uppercase" data-id="element-273" data-mp="2wakwcmbgjc07">{b.title}</h3>
                {b.lines.map(l => <p key={l} className="mt-2 text-sm leading-relaxed text-ink-muted" data-id="element-274" data-mp="2rducdnwj7w9i">{l}</p>)}
              </li>;
        })}
        </ul>
      </div>
      <div className="mt-12 overflow-hidden" data-id="element-275" data-mp="2hf4xm3zxmrxh">
        <div className="animate-marquee flex w-max gap-3" data-id="element-276" data-mp="2dcrrvfl6qu0p">
          {loop.map((img, i) => <img key={i} src={img.src} alt={i < galleryImages.length ? img.alt : ""} aria-hidden={i >= galleryImages.length} className="h-56 w-48 shrink-0 object-cover md:h-72 md:w-60" data-id="element-277" data-mp="fn080z5wo6px" data-mpi={i} />)}
        </div>
      </div>
      <div className="mt-12 px-4 text-center font-heading text-xl font-bold uppercase leading-snug md:text-2xl" data-id="element-278" data-mp="253lyovu83v6o">
        <p data-id="element-279" data-mp="29v453zf0mnz1">One project.</p>
        <p data-id="element-280" data-mp="29wf3tktlt5ja">Two functions.</p>
        <p className="text-brand" data-id="element-281" data-mp="29woz9nxf44wd">More value from every build.</p>
      </div>
    </section>;
}